import { render, staticRenderFns } from "./AddAnnex.vue?vue&type=template&id=355c3e9e&scoped=true&"
import script from "./AddAnnex.vue?vue&type=script&lang=js&"
export * from "./AddAnnex.vue?vue&type=script&lang=js&"
import style0 from "./AddAnnex.vue?vue&type=style&index=0&id=355c3e9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c3e9e",
  null
  
)

export default component.exports